import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  rippleContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
    borderRadius: "inherit",
    pointerEvents: "none",
  },
  
  ripple: {
    position: "absolute",
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.6)",
    transform: "scale(0)",
    animation: "$rippleEffect 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    pointerEvents: "none",
  },
  
  "@keyframes rippleEffect": {
    "0%": {
      transform: "scale(0)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(4)",
      opacity: 0,
    },
  },
}));

const RippleEffect = ({ trigger, color = "rgba(255, 255, 255, 0.6)" }) => {
  const classes = useStyles();
  const [ripples, setRipples] = useState([]);

  useEffect(() => {
    if (trigger) {
      const newRipple = {
        id: Date.now(),
        x: trigger.x,
        y: trigger.y,
        size: Math.max(trigger.width, trigger.height) * 2,
      };
      
      setRipples(prev => [...prev, newRipple]);
      
      // Remove ripple after animation
      setTimeout(() => {
        setRipples(prev => prev.filter(ripple => ripple.id !== newRipple.id));
      }, 600);
    }
  }, [trigger]);

  return (
    <div className={classes.rippleContainer}>
      {ripples.map(ripple => (
        <span
          key={ripple.id}
          className={classes.ripple}
          style={{
            left: ripple.x - ripple.size / 2,
            top: ripple.y - ripple.size / 2,
            width: ripple.size,
            height: ripple.size,
            background: color,
          }}
        />
      ))}
    </div>
  );
};

export default RippleEffect;
